import { NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, model } from "@angular/core";
import { StrategyDspCreativeType } from "@front/m19-api-client";
import { IIcon, IIconComponent, ILabelComponent, IRadioComponent, IRadioGroupComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-dsp-creative-type-selector",
  imports: [TranslocoDirective, NgClass, IIconComponent, IRadioComponent, IRadioGroupComponent, ILabelComponent],
  template: `<IRadioGroup
    name="creativeType"
    class="flex gap-4"
    *transloco="let t"
    [value]="creativeType()"
    (valueChange)="select($event)"
  >
    <label
      iLabel
      [for]="CreativeType.COMPONENT"
      class="flex w-64 cursor-pointer items-center justify-between gap-2"
      type="card"
    >
      <div class="flex flex-row items-center gap-4">
        <IIcon
          name="creatives"
          class="text-2xl"
          [ngClass]="creativeType() === CreativeType.COMPONENT ? 'text-main' : 'text-gray-500'"
        />
        <div class="font-medium text-gray-800">
          {{ t(DspCreativeTypeDescriptions[CreativeType.COMPONENT].title) }}
        </div>
      </div>
      <IRadio [id]="CreativeType.COMPONENT" [value]="CreativeType.COMPONENT" size="lg" />
    </label>
    <label iLabel [for]="CreativeType.VIDEO" class="flex w-64 cursor-pointer items-center gap-2" type="card">
      <div class="flex flex-row items-center gap-4">
        <IIcon
          [name]="DspCreativeTypeDescriptions[CreativeType.VIDEO].icon"
          class="text-2xl"
          [ngClass]="creativeType() === CreativeType.VIDEO ? 'text-main' : 'text-gray-500'"
        />
        <div class="font-medium text-gray-800">{{ t(DspCreativeTypeDescriptions[CreativeType.VIDEO].title) }}</div>
      </div>
      <IRadio [id]="CreativeType.VIDEO" [value]="CreativeType.VIDEO" size="lg" />
    </label>
  </IRadioGroup>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspCreativeTypeSelectorComponent {
  readonly CreativeType = StrategyDspCreativeType;
  readonly DspCreativeTypeDescriptions = DspCreativeTypeDescriptions;

  readonly creativeType = model.required<StrategyDspCreativeType>();

  select(creativeType?: StrategyDspCreativeType) {
    if (!creativeType) {
      return;
    }
    this.creativeType.set(creativeType);
  }
}

export const DspCreativeTypeDescriptions: Record<
  StrategyDspCreativeType,
  {
    title: string;
    icon: IIcon;
  }
> = {
  [StrategyDspCreativeType.COMPONENT]: {
    title: "dsp-creative-type-selector.display",
    icon: "creatives",
  },
  [StrategyDspCreativeType.VIDEO]: {
    title: "dsp-creative-type-selector.video",
    icon: "video",
  },
  [StrategyDspCreativeType.STREAMING_TV]: {
    title: "dsp-media-selector.streaming_tv",
    icon: "tv",
  },
  [StrategyDspCreativeType.VIDEO_DEAL]: {
    title: "dsp-media-selector.video_deal",
    icon: "play",
  },
};
